import { FormattedMessage, useIntl } from 'react-intl'
import { useLocation, useNavigate } from '@tanstack/react-router'

import { Tabs } from '@gto/ui/tabs'

import type { EdgeHistoryTab } from '@/pages/rewards/constants'
import { edgeHistoryTabs, EdgeHistoryTabsSchema } from '@/pages/rewards/constants'

import { EarningsHistoryTable } from './earnings-history-table'
import { RedemptionsHistoryTable } from './redemptions-history-table'
import { TransactionsHistoryTable } from './transactions-history-table'

export const HistoryTabs = () => {
  const intl = useIntl()
  const { hash }: { hash: EdgeHistoryTab } = useLocation()
  const navigate = useNavigate()

  const safeTab = EdgeHistoryTabsSchema.safeParse(hash).success ? hash : 'earnings'
  const renderTabContent = () => {
    switch (safeTab) {
      case 'earnings':
        return <EarningsHistoryTable />
      case 'redemptions':
        return <RedemptionsHistoryTable />
      case 'audit':
        return <TransactionsHistoryTable />
      default:
        return null
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <Tabs.Root
        detached
        fullWidth
        value={safeTab}
        onValueChange={(value) => {
          navigate({
            to: '.',
            hash: value,
          }).catch(console.error)
        }}
      >
        <Tabs.List aria-label={intl.formatMessage({ id: 'header.navigation.rewards.edgeHistory' })}>
          {edgeHistoryTabs.map((tab) => (
            <Tabs.Tab
              key={tab}
              value={tab}
            >
              <FormattedMessage id={`edge.history.tabs.${tab}`} />
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.Root>
      {renderTabContent()}
    </div>
  )
}
